<template>
    <div class="flex-grow-1 d-flex flex-column">
        <div class="d-flex justify-content-between align-items-center">
            <b-form-group class="mr-4 mb-4">
                <b-form-radio-group v-model="toggle.historical.value"
                                    buttons
                                    button-variant="outline-teal"
                                    class="text-small"
                                    :options="toggle.historical.options">
                </b-form-radio-group>
            </b-form-group>
            <refresh-button
                    @click="refresh"
                    :spinning="refreshing"
            >
            </refresh-button>
        </div>
        <div class="flex-grow-1 d-flex">
            <ag-grid-vue
                    :style="'width: ' + gridWidth +'%;'"
                    class="ag-theme-balham"

                    :gridOptions="gridOptions"
                    :defaultColDef="defaultColDef"
                    :columnDefs="columnDefs"
                    :columnTypes="columnTypes"
                    :rowData="rowData"

                    rowSelection="single"

                    @gridReady="onGridReady"
                    :floatingFilter="floatingFilter"
                    :cacheQuickFilter="cacheQuickFilter"

                    :suppressExcelExport="suppressExcelExport"
                    :suppressContextMenu="true"

                    :isExternalFilterPresent="isExternalFilterActive"
                    :doesExternalFilterPass="doesExternalFilterPass"

                    @cellClicked="onCellClicked"
                    :headerHeight="rowHeight"
                    :rowHeight="rowHeight"
            >
            </ag-grid-vue>
        </div>
    </div>
</template>

<script>
import {
  gridDefaultColDef,
  columnTypes,
  gridColumns,
} from '@/services/Property/PropertyAssessmentGrid';
import GridMixin from '@/components/Grid/GridMixin';
import PropertyAssessment from '@/services/Property/PropertyAssessment';
import dayjs from 'dayjs';
import RefreshButton from '@/components/Grid/RefreshButton';

export default {
  name: 'Property-Assessment-Grid',
  components: {
    RefreshButton,
  },
  mixins: [GridMixin],
  props: {
    property: {
      required: true,
      type: Object,
    },
    shown: {
      type: Boolean,
    },
  },
  data() {
    return {
      rowData: [],
      defaultColDef: gridDefaultColDef,
      columnDefs: gridColumns,
      columnTypes,
      toggle: {
        historical: {
          value: false,
          options: [
            { html: 'Current<span class="d-none d-sm-inline"> assessments</span>', value: false },
            { html: 'Historic<span class="d-none d-sm-inline"> assessments</span>', value: true },
          ],
        },
      },
    };
  },
  watch: {
    'toggle.historical.value': function () {
      this.gridApi.onFilterChanged();
    },
    shown() {
      this.gridApi.sizeColumnsToFit();
    },
  },
  methods: {
    postGridReady() {
      this.setRowClasses();

      this.refresh();
    },

    async refresh() {
      this.refreshing = true;
      try {
        const { data } = await PropertyAssessment.list(this.property.propertyId);
        this.rowData = data.assessments;
      } finally {
        this.refreshing = false;
      }
    },

    /**
     * Set row classes
     */
    setRowClasses() {
      const now = dayjs();
      const threeMonths = dayjs().add(3, 'month');

      this.gridOptions.getRowClass = ({ data }) => {
        if (!data) {
          return '';
        }

        if (!data.historic && data.renewalDate) {
          if (now.isAfter(dayjs(data.renewalDate))) {
            return 'red-row';
          }
          if (threeMonths.isAfter(dayjs(data.renewalDate))) {
            return 'orange-row';
          }
        }

        return '';
      };
    },

    doesExternalFilterPass(node) {
      const { historic } = node.data;

      // Show only historical
      if (this.toggle.historical.value) {
        return historic;
      }

      return !historic;
    },

    isExternalFilterActive() {
      return true;
    },
  },
};
</script>

<style lang="scss">
    .overflow-cell {
        padding-left: 0 !important;
        padding-right: 0 !important;
        text-align: center;

        &.ag-cell-focus {
            border-color: transparent !important;
        }
    }
</style>
